import { render, staticRenderFns } from "./MonitoringTransfers.vue?vue&type=template&id=37a2bea0&lang=pug"
import script from "./MonitoringTransfers.vue?vue&type=script&lang=js"
export * from "./MonitoringTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports